import { render, staticRenderFns } from "./IconSvgMore.vue?vue&type=template&id=71387292&scoped=true&"
import script from "./IconSvgMore.vue?vue&type=script&lang=js&"
export * from "./IconSvgMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71387292",
  null
  
)

export default component.exports